import React from "react";
import clsx from "clsx";

import styles from "./Item.styles";

const ServiceItem = ({ icon, text }) => {
	const css = styles();
	return (
		<div className={clsx(css.item, "mco-extension-component-services__item")}>
			<img className={clsx(css.icon, "mco-extension-component-services__icon")} src={"/img/icons/" + icon + ".svg"} alt=""/>
			{text &&
				<div className={clsx(css.text, "mco-extension-component-services__text")} dangerouslySetInnerHTML={{ __html: text }}></div>
			}
		</div>
	);
};

export default ServiceItem;